module.exports = "/images/aerial-3.jpg";